export const useFirstTimestampOfWeek = () => {
  const firstTimestampOfWeek = new Date();
  firstTimestampOfWeek.setHours(0, 0, 0, 0);
  firstTimestampOfWeek.setDate(
    firstTimestampOfWeek.getDate() - firstTimestampOfWeek.getDay() + 1
  );

  return firstTimestampOfWeek.getTime();
};
